import { useEffect, useState } from 'react';
import { sendGetRequest, sendPostRequest } from '../../../actions/app-actions';
import { connect, useDispatch } from 'react-redux';
import { withRouter, notification } from '../../../utils/utility';
import { setCurrentUser } from '../../../actions/authActions';
import Loader from '../../../components/Loader/Loader';
import * as Yup from "yup";
import { Formik, Form } from "formik";
import { Button, Col } from "reactstrap";
import FormField from "../../../components/FormField/FormField";
import isEmpty from "../../../validation/is-empty";


const Google2FASchema = Yup.object().shape({
  otp: Yup.string()
    .matches(/^\d+$/, 'OTP (One-time password) must contain digits only')
    .min(6, "OTP (One-time password) too short!")
    .max(6, "Maximum six digit are allowed")
    .required("OTP (One-time password) is required.")
});

const Google2FA = (props) => {

    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState(null);

    useEffect(() => {
        get2FASetup();
    }, []);

    const get2FASetup = () => {
        setIsLoading(true);
        props.sendGetRequest({
            url: `2fa/setup`,
            onSuccess: function (response) {
                setData(response);
                setIsLoading(false);
            },
            onError: function (error) {
                setIsLoading(false);
            }
        });
    }

    

    

    return (
        <>
            <Loader isShowLoader={isLoading} />
            <div class="rd_vacationfilterpart rd_vacationfilterpart3">
                <div class="rd_profilerd_erpart">
                    <div className="col-12" style={{ padding: '15px 20px' }}>
                        <h2 className='mb-1 mt-2'>Enable / Disable Two-Factor Authentication (2FA)</h2>
                    </div>
                    <div className="col-12 px-0">
                        <div className="rd_vacationflex2">
                            <p>
                                Set up your two factor authentication by scanning the barcode below. Alternatively, you can use the below code 
                                &nbsp;&nbsp;
                            </p>
                            <h3 className='mb-2'>
                                Setup key : {data?.secret}
                            </h3>
                            <p>Ensure you submit the current one because it refreshes every 30 seconds.</p>
                            {data && data?.qrCodeSvg && (
                                <img src={`data:image/svg+xml;base64,${data?.qrCodeSvg}`} className="w-auto" alt="QR Code"></img>
                            )}
                        </div>
                        <Formik
                            initialValues={{
                                otp: "",
                            }}
                            validationSchema={Google2FASchema}
                            onSubmit={(values, formHelper) => {
                                const { sendPostRequest } = props;
                                const { otp } = values;
                                setIsLoading(true);

                                const is2FAEnabled = props.auth.user?.google_2fa_status == 'E';
                                let url = `/2fa/disable`;
                                let formData = { otp };
                                if (!is2FAEnabled) {
                                    url = '/2fa/enable';
                                    formData.google_2fa_secret = data?.secret;
                                }
                                sendPostRequest({
                                    url,
                                    data: formData,
                                    onSuccess: function (response) {
                                        setIsLoading(false);
                                        if (response.success) {
                                            notification.success(response?.message);
                                            let user = {...props.auth.user};
                                            user.google_2fa_status = is2FAEnabled ? 'D' : 'E';
                                            console.log('user', user);
                                            dispatch(setCurrentUser(user));
                                            if (user.google_2fa_status == 'D') { get2FASetup(); }
                                        }
                                    },
                                    onError: function (error) {
                                        setIsLoading(false);
                                        const { data: responseData } = error.response;
                                        if (!responseData.success) {
                                            if (isEmpty(responseData?.data && !isEmpty(responseData?.message)) ) {
                                                notification.error(responseData?.message);
                                                formHelper.setFieldError(responseData?.message);
                                            }
                                        }
                                    },
                                });
                            }}
                        >
                        {(formProps) => {
                        const { values, errors, touched, handleChange, setFieldValue } =
                            formProps;

                            return (
                                <Form>
                                <div>
                                    <div>
                                        <div className="col-md-6 px-0">
                                            <div class="rd_vacationflex2">
                                                <p>Enter OTP from Google Authenticator App *</p>
                                                <div class="rd_profilethingco">
                                                    <FormField
                                                    type="otp"
                                                    name="otp"
                                                    placeholder="Time-based One time Password"
                                                    errors={errors}
                                                    touched={touched}
                                                    onChange={({ target }) => {
                                                        const { value } = target;
                                                        handleChange({
                                                            target: { name: "otp", value },
                                                        });
                                                    }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <Col lg="12" md="12" sm="12">
                                        {props.auth.user?.google_2fa_status != 'E' ? (
                                            <Button
                                                type="submit"
                                                className="btn btn-app col-md-2 col-lg-2 col-sm-12 float-left mb-5"
                                            >
                                                Enable 2FA
                                            </Button>
                                        ) : (
                                            <button
                                                type="submit"
                                                className="rd_cancel col-md-2 col-lg-2 col-sm-12 float-left mb-5"
                                            >
                                                Disable 2FA
                                            </button>
                                        )}
                                        

                                    </Col>
                                </div>
                                </Form>
                            );
                        }}
                        </Formik>
                    </div>
                </div>
            </div>
        </>
    );
}

const mapStateToProps = (state) => ({
  auth: state.auth
});

export default connect(mapStateToProps, { 
    sendGetRequest, 
    sendPostRequest  
})(withRouter(Google2FA));
